import { NetworkError, deepCamelCase, searchQueryString } from '../../../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type PutUserAlbumVideoLikesFields = readonly string[];

/** Options for PUT /users/{user_id}/albums/{album_id}/videos/{video_id}/likes */
export type PutUserAlbumVideoLikesOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the user.
     */
    userId: number;
    /**
     * The ID of the showcase.
     */
    albumId: number;
    /**
     * The ID of the video.
     */
    videoId: number;
  };

  /** Possible query parameters for /users/{user_id}/albums/{album_id}/videos/{video_id}/likes */
  query?: {
    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };
};

/** Result type for PUT /users/{user_id}/albums/{album_id}/videos/{video_id}/likes */
export type PutUserAlbumVideoLikesResult<Paths extends readonly string[]> = unknown;

/**
 * Cause the user to like a video
 * This method causes the authenticated user to like the specified video. The user can't like their own video.
 */
export async function putUserAlbumVideoLikes<Paths extends PutUserAlbumVideoLikesFields>({
  baseUrl,
  where: { userId, albumId, videoId },
  query,
  ...options
}: PutUserAlbumVideoLikesOptions<Paths>): Promise<PutUserAlbumVideoLikesResult<Paths>> {
  let res = await fetch(
    `${baseUrl}/users/${userId}/albums/${albumId}/videos/${videoId}/likes?${searchQueryString(
      query,
    )}`,
    {
      ...options,
      method: 'PUT',
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as PutUserAlbumVideoLikesResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}

export type DeleteUserAlbumVideoLikesFields = readonly string[];

/** Options for DELETE /users/{user_id}/albums/{album_id}/videos/{video_id}/likes */
export type DeleteUserAlbumVideoLikesOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the user.
     */
    userId: number;
    /**
     * The ID of the showcase.
     */
    albumId: number;
    /**
     * The ID of the video.
     */
    videoId: number;
  };

  /** Possible query parameters for /users/{user_id}/albums/{album_id}/videos/{video_id}/likes */
  query?: {
    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };
};

/** Result type for DELETE /users/{user_id}/albums/{album_id}/videos/{video_id}/likes */
export type DeleteUserAlbumVideoLikesResult<Paths extends readonly string[]> = unknown;

/**
 * Cause the user to unlike a video
 * This method causes the authenticated user to unlike the specified video.
 */
export async function deleteUserAlbumVideoLikes<Paths extends DeleteUserAlbumVideoLikesFields>({
  baseUrl,
  where: { userId, albumId, videoId },
  query,
  ...options
}: DeleteUserAlbumVideoLikesOptions<Paths>): Promise<DeleteUserAlbumVideoLikesResult<Paths>> {
  let res = await fetch(
    `${baseUrl}/users/${userId}/albums/${albumId}/videos/${videoId}/likes?${searchQueryString(
      query,
    )}`,
    {
      ...options,
      method: 'DELETE',
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as DeleteUserAlbumVideoLikesResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
